<template>
  <div class="print">
    <div class="page__header page__header-inside">
      <router-link :to="{ name: 'Main' }" class="page__header_title">
        ЭТО<b
          >ПРОСЧЕТ
          <span v-if="currentCalculation">{{
            currentCalculation.name
          }}</span></b
        >
      </router-link>

      <PrintManager />

      <div class="page__header_info">
        Заявка #{{ formatOrder
        }}<span
          >-
          <span class="page__header_name">{{ extra }}</span>
        </span>
        Для
        <span class="page__header_name">{{ user }}</span>
        от {{ time }}
      </div>
    </div>

    <div class="hide-print">
      <PrintItem v-if="currentCalculation" :currentItem="currentCalculation" />
    </div>

    <PrintText v-if="!false">
      <template #orderNumber>
        {{ formatOrder }}
      </template>

      <template #topDate> г. Москва {{ currentDate }} </template>
      <template #topFullname>
        <!--        Пономарев Алексей Михайлович-->
        {{ shopperInfo.lastName }}
        {{ shopperInfo.firstName }}
        {{ shopperInfo.middleName }}
      </template>
      <template #payMethod>
        <!--        наличными денежными средствами-->
        {{ shopperInfo.pay }}
      </template>
      <template #readyDate>
        <!--        15.09.2021-->
        {{ shopperInfo.date }}
      </template>
      <template #deliveryAddress>
        <!--        Москва, ул. Мелитопольская, д. 4А, стр. 10&#45;&#45;-->
        {{ shopperInfo.address.city }} , {{ shopperInfo.address.flat }} кв.,
        {{ shopperInfo.address.entrance }} подъезд,
        {{ shopperInfo.address.floor }} этаж.
      </template>
      <template #buyer>
        {{ shopperInfo.lastName }}
        {{ shopperInfo.firstName }}
        {{ shopperInfo.middleName }}
      </template>
      <template #fullName>
        {{ shopperInfo.lastName }}
        {{ shopperInfo.firstName }}
        {{ shopperInfo.middleName }}
      </template>
      <template #birthday>
        {{ shopperInfo.birthday }}
      </template>
      <template #passport>
        {{ shopperInfo.passport }}
      </template>
      <template #registration>
        {{ shopperInfo.registration }}
      </template>
      <template #phoneMain>
        {{ shopperInfo.number[0].tel }}
      </template>
      <template #phoneOther>
        <span v-for="phone in shopperInfo.number.slice(1)" :key="phone.id">
          {{ phone.tel }} ,
        </span>
      </template>
      <template #email>
        {{ shopperInfo.email }}
      </template>

      <template #table>
        <PrintItem
          v-if="currentCalculation"
          :currentItem="currentCalculation"
        />
      </template>
      <template #photo>
        <div class="calc__gallery">
          <img v-show="shopperInfo.file" :src="shopperInfo.file" alt="img" />
        </div>
      </template>
    </PrintText>
  </div>
</template>

<script>
import wNumb from "wnumb";
import PrintItem from "@/components/Print-item";
import PrintManager from "@/components/Print-manager";
import PrintText from "@/components/Print-text";
import ItemTemplate from "@/utils/ItemTemplate";

export default {
  name: "Offer",
  components: { PrintText, PrintManager, PrintItem },
  data() {
    return {
      isOpenDetails: false,
      currentDate: ""
    };
  },
  created() {
    this.generateCurrentDate();
  },
  computed: {
    photo() {
      return this.currentCalculation?.photo;
    },
    manager() {
      return this.$store.getters.manager;
    },
    currentOrder() {
      return this.$store.getters.currentOrder;
    },
    currentCalculation() {
      return this.$store.getters.currentCalculation;
    },
    user() {
      return this.currentOrder?.user;
    },
    time() {
      return this.currentOrder?.time;
    },
    extra() {
      return this.currentOrder?.extra;
    },
    formatOrder() {
      return wNumb({
        thousand: "-"
      }).to(this.currentOrder?.number ?? 0);
    },
    shopperInfo() {
      return this.currentOrder?.shopper ?? ItemTemplate.shopper();
    }
  },
  methods: {
    generateCurrentDate() {
      this.currentDate = new Intl.DateTimeFormat("ru", {
        year: "numeric",
        month: "long",
        day: "2-digit"
      }).format(new Date());
    }
  }
};
</script>
